import React from 'react';
import { useReveal } from '../lib/useReveal';
export function VideoSection() {
  const [ref1, vis1] = useReveal();
  const [ref2, vis2] = useReveal();
  return <section className="bg-[#1e1e30] py-14 md:py-20 px-4 border-t border-white/5" data-id="element-534">
      <div className="container mx-auto max-w-4xl" data-id="element-535">
        {/* Header */}
        <div ref={ref1} className={`reveal text-center mb-8 ${vis1 ? 'is-visible' : ''}`} data-id="element-536">
          <div className="inline-flex items-center gap-2 text-[#f0c040] text-xs font-bold tracking-[0.3em] uppercase mb-5" data-id="element-537">
            <span className="w-8 h-px bg-[#f0c040]/40" data-id="element-538"></span>
            Tómate unos minutos
            <span className="w-8 h-px bg-[#f0c040]/40" data-id="element-539"></span>
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white leading-tight mb-4" data-id="element-540">
            Así va a sonar{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#d4a017] via-[#f0c040] to-[#d4a017]" data-id="element-541">
              tu vida
            </span>
          </h2>
        </div>

        {/* Video with golden frame */}
        <div ref={ref2} className={`reveal ${vis2 ? 'is-visible' : ''}`} data-id="element-542">
          <div className="relative" data-id="element-543">
            <div className="absolute -inset-3 bg-gradient-to-br from-[#d4a017]/15 via-transparent to-[#d4a017]/15 rounded-3xl blur-2xl opacity-80" data-id="element-544"></div>
            <div className="relative p-1 rounded-2xl bg-gradient-to-br from-[#d4a017]/30 via-white/5 to-[#d4a017]/20 shadow-[0_20px_80px_rgba(0,0,0,0.5)] border border-white/10" data-id="element-545">
              <div className="rounded-xl overflow-hidden bg-[#0f0f1a]" data-id="element-546">
                <div className="aspect-video w-full" data-id="element-547">
                  <iframe src="https://www.youtube.com/embed/i-m-injF6xs?rel=0&modestbranding=1" title="Curso Integral de Reiki" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="w-full h-full" data-id="element-548" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}